import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Global } from 'shared-lib';

function isAeroTechUser(): boolean {
  return (Global.User.currentUser?.Organization?.Id && Global.User.currentUser.Organization.Id === 17) ?? false;
}

function getSelectedOrgId(): number | null {
  const selected = Global.User?.currentUser?.SelectedOrganizationId;
  if (selected != null) return Number(selected);

  const orgId = Global.User?.currentUser?.Organization?.Id;
  if (orgId == null) return null;

  if (Global.User?.currentUser?.IsSystemAdministrator || isAeroTechUser()) {
    return Number(Global.User.currentUser?.AdministratorOrganizationId ?? orgId);
  }
  return Number(orgId);
}

export const legacyOrgRewriteGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const selectedOrgId = getSelectedOrgId();
  if (!selectedOrgId || !Number.isFinite(selectedOrgId)) {
    return router.parseUrl('/'); // should be unreachable if cache boot completed
  }

  const url = state.url || '/';
  if (url === '/o' || url === '/o/') {
    return router.parseUrl(`/o/${selectedOrgId}/organization-summary`);
  }
  if (url.startsWith('/o/')) return true;

  const normalized = url.startsWith('/') ? url : `/${url}`;
  return router.parseUrl(`/o/${selectedOrgId}${normalized}`);
};

